export const PATHS = {
  HOME: "/",
  ABOUT: "/about-us",
  CAREER: "/career",
  CONTACT: "/contact-us",
  SERVICES: "/services",
};
